import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { searchResultsExecutionStatus, } from '@as-react/common-types';
import { Box, TextAlpha } from '@yonderland/andes-react';
const INITIAL_QUERY_PLACEHOLDER = '{{{INITIAL QUERY}}}';
const ALTERNATIVE_BRAND_PLACEHOLDER = '{{{ALTERNATIVE BRAND}}}';
const PartialSearchResultsTitles = ({ alternativeBrand, maybeMeant, maybeLike, executionStatus, alternativeQueryResults, initialSearchTerm, }) => {
    const getSuggestedSearchTerm = () => alternativeQueryResults[0].alternativeQuery;
    const getTitles = () => {
        let titles = [];
        switch (executionStatus) {
            case searchResultsExecutionStatus.ALT_BRAND:
                titles = alternativeBrand.title.split(ALTERNATIVE_BRAND_PLACEHOLDER);
                titles[0] = titles[0].replace(INITIAL_QUERY_PLACEHOLDER, initialSearchTerm);
                titles[1] = getSuggestedSearchTerm();
                return titles;
            case searchResultsExecutionStatus.ALT_QUERIES:
                titles = maybeMeant.title.split(INITIAL_QUERY_PLACEHOLDER);
                titles.splice(1, 0, initialSearchTerm);
                return titles;
            case searchResultsExecutionStatus.ALT_SPELL_UNCHANGED:
                titles = maybeLike.title.split(INITIAL_QUERY_PLACEHOLDER);
                titles.splice(1, 0, initialSearchTerm);
                return titles;
        }
        return titles;
    };
    const getDescription = () => {
        switch (executionStatus) {
            case searchResultsExecutionStatus.ALT_BRAND:
                return alternativeBrand.description.replace(ALTERNATIVE_BRAND_PLACEHOLDER, getSuggestedSearchTerm());
            case searchResultsExecutionStatus.ALT_QUERIES:
                return maybeMeant.description;
            case searchResultsExecutionStatus.ALT_SPELL_UNCHANGED:
                return maybeLike.description;
            default:
                return '';
        }
    };
    return (_jsxs(_Fragment, { children: [_jsx(Box, { paddingBlockStart: { base: '4', lg: '0' }, paddingBlockEnd: "4", children: _jsxs(TextAlpha, { as: "h1", variant: "headingS", children: [getTitles()[0], getTitles()[1] && (_jsxs(TextAlpha, { as: "span", variant: "inherit", children: ["\u201C", getTitles()[1], "\u201D"] })), getTitles()[2]] }) }), _jsx(TextAlpha, { strong: true, variant: "bodyM", children: getDescription() })] }));
};
export { PartialSearchResultsTitles };
